import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./SortableList.module.scss"

export interface Props extends ComponentPropsWithoutRef<"button"> {
  id: string; // TODO consider removing this
}

export const OverlayListItem = forwardRef<HTMLButtonElement, Props>(
  function OverlayListItem(props: Props, propsRef: Ref<HTMLButtonElement>) {
    const className = classNames(
      styles.overlayListItem,
      props.className,
    )

    return (
      <button
        {...props}
        ref={propsRef}
        className={className}
      />
    )
  },
)
